export default {
    namespaced: true,//将getters、mutations、actions路径引入到当前模块命名空间 配置后调用方法 this.$store.commit({type:('user/login')}) 其他方法同 可根据情况不适应此配置
    state:{
        leftList:[]
    },
    getters:{},
    mutations: { 
        getLeft(state,payload){
            state.leftList=payload.leftList;
        }
    },
    actions: { 

    }
}